import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { DeviceGroupView } from '..';
import { Icon, Button } from "signoxe/components/widgets";

import './styles.scss';

const DeviceGroupList = ({
  deviceGroups,
  screenshotsEnabled,
  smartBoardEnabled,
  deviceReportEnabled,
  onDeviceChange,
  rebootEnabled,
  RestartAppEnabled,
  ClearUnusedMediaEnabled,
  offlineEnabled,
  delayDownloadEnabled,
  onGroupFeedChange,
  onDeviceGroupDelete,
  onDeviceGroupChange,
  onClickSchedule,
  onPriorityMessageActivate,
  onPriorityMessageChange,
  onPriorityMessageDeactivate,
  queryString,
  handleUserReport,
  deviceTags,
  groupsOptionData
}) => {
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  console.log("currentPage", currentPage)


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDeviceGroups = deviceGroups.slice(indexOfFirstItem, indexOfLastItem);

  console.log("currentDeviceGroups", currentDeviceGroups)


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, Math.ceil(deviceGroups.length / itemsPerPage)));
  };


  return (
    <div className="device-groups">
  
    {currentDeviceGroups && currentDeviceGroups.map(group => (<DeviceGroupView key={group.id}
      handleUserReport={handleUserReport}
      screenshotsEnabled={screenshotsEnabled}
      smartBoardEnabled={smartBoardEnabled}
      deviceReportEnabled={deviceReportEnabled}
      rebootEnabled={rebootEnabled}
      RestartAppEnabled={RestartAppEnabled}
      ClearUnusedMediaEnabled={ClearUnusedMediaEnabled}
      offlineEnabled={offlineEnabled}
      delayDownloadEnabled={delayDownloadEnabled}
      deviceGroup={group}
      groupList={deviceGroups}
      groupsOptionData={groupsOptionData}
      onDeviceChange={onDeviceChange}
      onDeviceGroupDelete={onDeviceGroupDelete}
      onDeviceGroupChange={onDeviceGroupChange}
      onPriorityMessageActivate={onPriorityMessageActivate}
      onPriorityMessageChange={onPriorityMessageChange}
      onPriorityMessageDeactivate={onPriorityMessageDeactivate}
      onGroupFeedChange={onGroupFeedChange}
      onClickSchedule={onClickSchedule} 
      searchString={queryString}
      deviceTags={deviceTags}
    />))}

    {/* Pagination buttons */}
    {deviceGroups  && deviceGroups.length > itemsPerPage && <div className="pagination flex flex-jc-c flex-ai-c">
        <Button primary onClick={handlePrevPage} disabled={currentPage === 1}>
          Prev
        </Button>
        <span style={{marginLeft:"1rem", marginRight:"1rem"}}>{`Page ${currentPage} of ${Math.ceil(deviceGroups.length / itemsPerPage)}`}</span>

        <Button primary onClick={handleNextPage} disabled={currentPage === Math.ceil(deviceGroups.length / itemsPerPage)}>
          Next
        </Button>

      </div>}


  </div>
  )
};

DeviceGroupList.propTypes = {
  queryString: PropTypes.string.isRequired,
  deviceGroups: PropTypes.array.isRequired,
  screenshotsEnabled: PropTypes.bool,
  smartBoardEnabled: PropTypes.bool,
  deviceReportEnabled: PropTypes.bool,
  rebootEnabled: PropTypes.bool,
  RestartAppEnabled: PropTypes.bool,
  ClearUnusedMediaEnabled: PropTypes.bool,
  offlineEnabled: PropTypes.bool,
  delayDownloadEnabled: PropTypes.bool,
  onDeviceChange: PropTypes.func.isRequired,
  onDeviceGroupDelete: PropTypes.func.isRequired,
  onDeviceGroupChange: PropTypes.func.isRequired,
  onGroupFeedChange: PropTypes.func.isRequired,
  onClickSchedule: PropTypes.func.isRequired,
  onPriorityMessageChange: PropTypes.func.isRequired,
  onPriorityMessageActivate: PropTypes.func.isRequired,
  onPriorityMessageDeactivate: PropTypes.func.isRequired,
  handleUserReport:PropTypes.func.isRequired,
  deviceTags: PropTypes.object,
};

export default DeviceGroupList;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/DeviceGroupList/index.js